import React from 'react'
import { useParams } from 'react-router-dom'
import { useAuth } from '../../_helper/Auth/AuthProvider'
import { StudentTopMenuLayout } from '../../Layout/StudentTopMenu/StudentTopMenuLayout'
import { BragSheet } from './BragSheet'

const StudentBragSheet = () => {
	const { studentId } = useParams()
	const { user } = useAuth()
	const isInstructorView = user?.role === 'Instructor'
	const effectiveStudentId = isInstructorView ? studentId : user?.id

	return (
		<StudentTopMenuLayout activeMenu="BragSheet" pageName="BragSheet">
			<BragSheet studentId={effectiveStudentId} />
		</StudentTopMenuLayout>
	)
}

export { StudentBragSheet }
